<template>
  <div class="personal-buy grid grid-cols-3 gap-[12px]">
    <div v-for="item in packages" :key="item.id">
      <div
        :class="[
          'card rounded-[8px] cursor-pointer py-[24px] h-[140px]',
          {
            active: item.id === picked?.id,
          },
        ]"
        @click.stop="handlePick(item)"
      >
        <div v-if="item.free_credit_coins > 0" class="coin-free">
          {{
            $t('jia-song-itemfreecreditcoins-yan-bi', [item.free_credit_coins])
          }}
        </div>
        <div class="price font-bold text-center">
          <span class="price-prefix text-[16px]">
            {{ formatPrice(item.price).prefix }}
          </span>
          <span class="price-num text-[20px]">
            {{ formatPrice(item.price).value }}
          </span>
        </div>
        <div class="coin-count text-center">
          <div class="coin-value my-[12px]">
            <Resource
              :src="getFeUrl('/assets/credit.png')"
              :resourceOption="{
                resize: {
                  m: 'lfit',
                  h: 64,
                  w: 64,
                },
                format: 'webp',
              }"
              class="w-[20px] h-[20px]"
            />
            {{
              $t('gong-itemtotalcreditcoins-yan-bi', [item.total_credit_coins])
            }}
          </div>
          <div class="time-value">
            {{
              $t(
                'yu-ji-sheng-chan-getavailabletimecountitemtotalcreditcoins-shi-pin',
                [getAvailableTimeCount(item.total_credit_coins)]
              )
            }}
            <a-tooltip placement="right">
              <template #title>
                {{
                  $t(
                    'gen-ju-quan-ping-tai-yong-hu-ping-jun-xiao-shuai-ji-suan-shi-ji-xiao-hao-yan-bi-shu-yi-ge-ren-zhi-zuo-xiao-shuai-wei-zhun'
                  )
                }}
              </template>
              <iconpark-icon class="tip-icon" name="info"></iconpark-icon>
            </a-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ICreditCoinsPackage } from '~/api'
import { useTime } from '~/hooks/useTime'
import { formatPrice } from '~/utils/equity-helper'
import { isChinese } from '~/utils/area'
import Resource from '~/components/resource'
import { getFeUrl } from '~/utils/url'

const { $t } = useNuxtApp()

defineProps<{
  packages: ICreditCoinsPackage[]
  picked?: ICreditCoinsPackage
}>()

const emits = defineEmits(['change'])
const { formatDuration } = useTime()

const getAvailableTimeCount = (totalCreditCoins: number) => {
  return formatDuration(
    totalCreditCoins * (isChinese() ? 0.2 : 0.3) * 1000,
    (d) => {
      const s = d.seconds()
      const m = d.minutes()
      const h = d.hours()
      let str = ''
      if (s > 0) {
        str = $t('dseconds-miao', [d.seconds()])
      }
      if (m > 0 || h > 0) {
        str = $t('dminutes-fen-zhong', [m + h * 60]) + str
      }
      return str
    }
  )
}

const handlePick = (v: ICreditCoinsPackage) => emits('change', v)
</script>

<style scoped lang="scss">
.card {
  position: relative;
  border: 1px solid var(--back-5);
  line-height: 1;
  .price {
    color: var(--text-1);
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .coin-value {
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--warning-10);
    font-weight: 500;
    font-size: 14px;
  }
  .time-value {
    font-size: 12px;
    line-height: 1;
    color: var(--text-1-60);
    line-height: 1;
  }
}
.active {
  &.active {
    border: 1px solid var(--purple-5);
    background-color: var(--purple-2);
  }
}
.coin-free {
  position: absolute;
  left: -1px;
  top: -1px;
  font-weight: 500;
  background-color: var(--error-6);
  border-radius: 4px 4px 4px 0px;
  color: #ffffff;
  font-size: 12px;
  padding: 2px 8px;
  line-height: 1;
}
.title {
  font-weight: 500;
  font-size: 14px;
}
.tip-icon {
  font-size: 12px;
  transform: translateY(2px);
  color: var(--text-1);
}
</style>
